import { __assign, __read, __spreadArray, __values } from "tslib";
import { ProductTypeHelper, SearchMaskInputType, store } from "ltur-state-engine";
import FilterHelper from "FilterBar/Helper/FilterHelper";
import { format } from "date-fns";
var BaseFilterHelper = /** @class */ (function () {
    function BaseFilterHelper() {
    }
    BaseFilterHelper.mapStateToFilter = function () {
        var e_1, _a;
        var filterList = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            filterList[_i] = arguments[_i];
        }
        var lturState = store.getState();
        var searchMaskGroupType = ProductTypeHelper.mapToSearchMaskGroupType(lturState.websiteState.app.url.context.productType);
        var searchMaskGroup = lturState.websiteState.searchMask.searchMaskBundle.groups[searchMaskGroupType];
        try {
            for (var filterList_1 = __values(filterList), filterList_1_1 = filterList_1.next(); !filterList_1_1.done; filterList_1_1 = filterList_1.next()) {
                var filter = filterList_1_1.value;
                if (!this.coreMap[filter.identifier] || !searchMaskGroup.inputs[this.coreMap[filter.identifier].inputType]) {
                    console.error("no mapping for filter: [ ".concat(filter.identifier, " ]"));
                    continue;
                }
                var searchMaskInput = searchMaskGroup.inputs[this.coreMap[filter.identifier].inputType];
                if (searchMaskInput.confirmedValue) {
                    filter.setFilter(this.coreMap[filter.identifier].mapFromState(filter, searchMaskInput));
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (filterList_1_1 && !filterList_1_1.done && (_a = filterList_1.return)) _a.call(filterList_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    BaseFilterHelper.mapFilterToState = function (filter) {
        if (!this.coreMap[filter.identifier]) {
            console.error("no mapping for filter: [ ".concat(filter.identifier, " ]"));
            return;
        }
        var lturState = store.getState();
        var searchMaskGroupType = ProductTypeHelper.mapToSearchMaskGroupType(lturState.websiteState.app.url.context.productType);
        var searchMaskGroup = lturState.websiteState.searchMask.searchMaskBundle.groups[searchMaskGroupType];
        var searchMaskInput = searchMaskGroup.inputs[this.coreMap[filter.identifier].inputType];
        searchMaskInput.confirmedValue.value = this.coreMap[filter.identifier].mapToState(filter, searchMaskInput);
        FilterHelper.dispatchToState(searchMaskInput, searchMaskGroupType);
    };
    BaseFilterHelper.coreMap = {
        childPriceFilter: {
            inputType: SearchMaskInputType.DEALS,
            mapToState: function (filter, input) { return filter.model ? [2003] : input.defaultValue.value; },
            mapFromState: function (filter, input) { var _a; return ((_a = input.confirmedValue.value) === null || _a === void 0 ? void 0 : _a.includes(2003)) || false; },
        },
        summerDealFilter: {
            inputType: SearchMaskInputType.DEALS,
            mapToState: function (filter, input) { return filter.model ? [2006] : input.defaultValue.value; },
            mapFromState: function (filter, input) { var _a; return ((_a = input.confirmedValue.value) === null || _a === void 0 ? void 0 : _a.includes(2006)) || false; },
        },
        dealsFilter: {
            inputType: SearchMaskInputType.DEALS,
            mapToState: function (filter, input) { return filter.model ? [2002] : input.defaultValue.value; },
            mapFromState: function (filter, input) { var _a; return ((_a = input.confirmedValue.value) === null || _a === void 0 ? void 0 : _a.includes(2002)) || false; },
        },
        earlyBirdFilter: {
            inputType: SearchMaskInputType.DEALS,
            mapToState: function (filter, input) { return filter.model ? [2007] : input.defaultValue.value; },
            mapFromState: function (filter, input) { var _a; return ((_a = input.confirmedValue.value) === null || _a === void 0 ? void 0 : _a.includes(2007)) || false; },
        },
        lastMinuteDealFilter: {
            inputType: SearchMaskInputType.DEALS,
            mapToState: function (filter, input) { return filter.model ? [2004] : input.defaultValue.value; },
            mapFromState: function (filter, input) { var _a; return ((_a = input.confirmedValue.value) === null || _a === void 0 ? void 0 : _a.includes(2004)) || false; },
        },
        flexFilter: {
            inputType: SearchMaskInputType.DEALS,
            mapToState: function (filter, input) { return filter.model ? [2005] : input.defaultValue.value; },
            mapFromState: function (filter, input) { var _a; return ((_a = input.confirmedValue.value) === null || _a === void 0 ? void 0 : _a.includes(2005)) || false; },
        },
        priceFilter: {
            inputType: SearchMaskInputType.PRICE_RANGE,
            mapToState: function (filter, input) {
                return __assign(__assign({}, input.defaultValue.value), { priceMin: filter.model[0] === 0 ? null : filter.model[0], priceMax: filter.model[1] === 6000 ? null : filter.model[1] });
            },
            mapFromState: function (filter, input) { return [input.confirmedValue.value.priceMin === null ? 0 : input.confirmedValue.value.priceMin, input.confirmedValue.value.priceMax === null ? 6000 : input.confirmedValue.value.priceMax]; },
        },
        outBoundFlightTimeFliter: {
            inputType: SearchMaskInputType.FLIGHT_DEPARTURE_TIME_RANGE,
            mapToState: function (filter, input) { return filter.model.includes(0) && filter.model.includes(24) ? null :
                filter.model.map(function (i) { return i === 24 ? '23:59' : i.toLocaleString('de-DE', { minimumIntegerDigits: 2 }) + ':00'; }); },
            mapFromState: function (filter, input) { return input.confirmedValue.value ? [Number(input.confirmedValue.value[0].split(':')[0]), input.confirmedValue.value[1] === '23:59' ? 24 : Number(input.confirmedValue.value[1].split(':')[0])] : [0, 24]; },
        },
        inBoundFlightTimeFliter: {
            inputType: SearchMaskInputType.FLIGHT_RETURN_TIME_RANGE,
            mapToState: function (filter, input) { return filter.model.includes(0) && filter.model.includes(24) ? null :
                filter.model.map(function (i) { return i === 24 ? '23:59' : i.toLocaleString('de-DE', { minimumIntegerDigits: 2 }) + ':00'; }); },
            mapFromState: function (filter, input) { return input.confirmedValue.value ? [Number(input.confirmedValue.value[0].split(':')[0]), input.confirmedValue.value[1] === '23:59' ? 24 : Number(input.confirmedValue.value[1].split(':')[0])] : [0, 24]; },
        },
        flightStopsFilter: {
            inputType: SearchMaskInputType.FLIGHT_STOP_OVER_MAX,
            mapToState: function (filter, input) { return filter.model === -1 ? null : filter.model; },
            mapFromState: function (filter, input) { return input.confirmedValue.value === null ? -1 : input.confirmedValue.value; },
        },
        transferFilter: {
            inputType: SearchMaskInputType.TRANSFER,
            mapToState: function (filter, input) { return filter.model; },
            mapFromState: function (filter, input) { return input.confirmedValue.value; },
        },
        trainToFlightFilter: {
            inputType: SearchMaskInputType.TRAIN_TO_FLIGHT,
            mapToState: function (filter, input) { return filter.model; },
            mapFromState: function (filter, input) { return input.confirmedValue.value; },
        },
        categoryFilter: {
            inputType: SearchMaskInputType.HOTEL_CATEGORY,
            mapToState: function (filter, input) {
                var mapping = new Map([
                    [1201, null],
                    [1202, 3],
                    [1203, 4],
                    [1204, 5],
                ]);
                return mapping.get(filter.model);
            },
            mapFromState: function (filter, input) {
                var mapping = new Map([
                    [null, 1201],
                    [3, 1202],
                    [4, 1203],
                    [5, 1204],
                ]);
                return mapping.get(input.confirmedValue.value);
            },
        },
        boardFilter: {
            inputType: SearchMaskInputType.HOTEL_BOARD_CODES,
            mapToState: function (filter, input) { return filter.model === filter.initialValue ? null : filter.model; },
            mapFromState: function (filter, input) { return input.confirmedValue.value === null ? 1401 : input.confirmedValue.value; },
        },
        roomFilter: {
            inputType: SearchMaskInputType.HOTEL_ROOM_CODES,
            mapToState: function (filter, input) { return filter.model === filter.initialValue ? null : filter.model; },
            mapFromState: function (filter, input) { return input.confirmedValue.value === null ? 1301 : input.confirmedValue.value; },
        },
        holidaycheckFilter: {
            inputType: SearchMaskInputType.HOTEL_RATING,
            mapToState: function (filter, input) { return filter.model === filter.initialValue ? null : filter.model; },
            mapFromState: function (filter, input) { return input.confirmedValue.value === null ? 1901 : input.confirmedValue.value; },
        },
        recommendationFilter: {
            inputType: SearchMaskInputType.HOTEL_RECOMMENDATIONS,
            mapToState: function (filter, input) { return filter.model[0] === 0 ? null : (filter.model[0] / 10) + 1800; },
            mapFromState: function (filter, input) { return input.confirmedValue.value === null ? [0] : [(input.confirmedValue.value - 1800) * 10]; },
        },
        locationFilter: {
            inputType: SearchMaskInputType.LOCATION,
            mapToState: function (filter, input) { return filter.model === 1101 ? null : filter.model; },
            mapFromState: function (filter, input) { return input.confirmedValue.value === null ? 1101 : input.confirmedValue.value; },
        },
        featuresFilter: {
            inputType: SearchMaskInputType.FEATURES,
            mapToState: function (filter, input) { return filter.items.map(function (i) { return i.id; }).filter(function (v, i) { return filter.model[i]; }); },
            mapFromState: function (filter, input) { return filter.items.map(function (i) { return i.id; }).map(function (v) { var _a; return ((_a = input.confirmedValue.value) === null || _a === void 0 ? void 0 : _a.includes(v)) || false; }); },
        },
        targetGroupFilter: {
            inputType: SearchMaskInputType.TARGET_GROUPS,
            mapToState: function (filter, input) { return filter.items.map(function (i) { return i.id; }).filter(function (v, i) { return filter.model[i]; }); },
            mapFromState: function (filter, input) { return filter.items.map(function (i) { return i.id; }).map(function (v) { var _a; return ((_a = input.confirmedValue.value) === null || _a === void 0 ? void 0 : _a.includes(v)) || false; }); },
        },
        sportFilter: {
            inputType: SearchMaskInputType.SPORTS,
            mapToState: function (filter, input) { return filter.items.map(function (i) { return i.id; }).filter(function (v, i) { return filter.model[i]; }); },
            mapFromState: function (filter, input) { return filter.items.map(function (i) { return i.id; }).map(function (v) { var _a; return ((_a = input.confirmedValue.value) === null || _a === void 0 ? void 0 : _a.includes(v)) || false; }); },
        },
        accommodationTypeFilter: {
            inputType: SearchMaskInputType.ACCOMMODATION_TYPE_CODES,
            mapToState: function (filter, input) { return filter.model === filter.initialValue ? null : [filter.model]; },
            mapFromState: function (filter, input) { return input.confirmedValue.value === null ? filter.initialValue : input.confirmedValue.value; },
        },
        wintersportFilter: {
            inputType: SearchMaskInputType.WINTERSPORTS,
            mapToState: function (filter, input) { return filter.items.map(function (i) { return i.id; }).filter(function (v, i) { return filter.model[i]; }); },
            mapFromState: function (filter, input) { return filter.items.map(function (i) { return i.id; }).map(function (v) { var _a; return ((_a = input.confirmedValue.value) === null || _a === void 0 ? void 0 : _a.includes(v)) || false; }); },
        },
        wellnessFilter: {
            inputType: SearchMaskInputType.WELLNESS,
            mapToState: function (filter, input) { return filter.items.map(function (i) { return i.id; }).filter(function (v, i) { return filter.model[i]; }); },
            mapFromState: function (filter, input) { return filter.items.map(function (i) { return i.id; }).map(function (v) { var _a; return ((_a = input.confirmedValue.value) === null || _a === void 0 ? void 0 : _a.includes(v)) || false; }); },
        },
        familyFilter: {
            inputType: SearchMaskInputType.FAMILY,
            mapToState: function (filter, input) { return filter.items.map(function (i) { return i.id; }).filter(function (v, i) { return filter.model[i]; }); },
            mapFromState: function (filter, input) { return filter.items.map(function (i) { return i.id; }).map(function (v) { var _a; return ((_a = input.confirmedValue.value) === null || _a === void 0 ? void 0 : _a.includes(v)) || false; }); },
        },
        roomCharacteristicsFilter: {
            inputType: SearchMaskInputType.ROOMCHARACTERISTICS,
            mapToState: function (filter, input) { return filter.items.map(function (i) { return i.id; }).filter(function (v, i) { return filter.model[i]; }); },
            mapFromState: function (filter, input) { return filter.items.map(function (i) { return i.id; }).map(function (v) { var _a; return ((_a = input.confirmedValue.value) === null || _a === void 0 ? void 0 : _a.includes(v)) || false; }); },
        },
        travelThemeFilter: {
            inputType: SearchMaskInputType.TRAVEL_THEMES,
            mapToState: function (filter, input) {
                var _a, _b;
                var mapped = filter.items.map(function (i) { return i.id; }).filter(function (v, i) { return filter.model[i]; });
                if (mapped.includes(2103))
                    (_b = (_a = BaseFilterHelper.filterBar) === null || _a === void 0 ? void 0 : _a.filterMap.ulmFilter) === null || _b === void 0 ? void 0 : _b.reset(true);
                return mapped;
            },
            mapFromState: function (filter, input) { return filter.items.map(function (i) { return i.id; }).map(function (v) { var _a; return ((_a = input.confirmedValue.value) === null || _a === void 0 ? void 0 : _a.includes(v)) || false; }); },
        },
        seaViewRoomFilter: {
            inputType: SearchMaskInputType.ROOMCHARACTERISTICS,
            mapToState: function (filter, input) { var _a; return filter.model ? input.confirmedValue.value ? __spreadArray(__spreadArray([], __read(input.confirmedValue.value), false), [2301], false) : [2301] : ((_a = input.confirmedValue.value) === null || _a === void 0 ? void 0 : _a.filter(function (x) { return x !== 2301; })) || null; },
            mapFromState: function (filter, input) { var _a; return !!((_a = input.confirmedValue.value) === null || _a === void 0 ? void 0 : _a.find(function (x) { return x === 2301; })); },
        },
        airlineFilter: {
            inputType: SearchMaskInputType.OTHER_CODES,
            mapToState: function (filter, input) {
                return __assign(__assign({}, input.confirmedValue.value), { airlineCodes: filter.items.map(function (i) { return i.id; }).filter(function (v, i) { return filter.model[i]; }) });
            },
            mapFromState: function (filter, input) { return filter.items.map(function (i) { var _a, _b; return ((_b = (_a = input.confirmedValue.value) === null || _a === void 0 ? void 0 : _a.airlineCodes) === null || _b === void 0 ? void 0 : _b.includes(i.id)) || false; }); }
        },
        tourOperatorFilter: {
            inputType: SearchMaskInputType.OTHER_CODES,
            mapToState: function (filter, input) {
                if (!filter.model.includes(true)) {
                    delete input.confirmedValue.value.tourOperatorCodes;
                    return input.confirmedValue.value;
                }
                return __assign(__assign({}, input.confirmedValue.value), { tourOperatorCodes: filter.items.map(function (i) { return i.id; }).filter(function (v, i) { return filter.model[i]; }).join().split(',') });
            },
            mapFromState: function (filter, input) { return filter.items.map(function (i) {
                var e_2, _a;
                var _b, _c;
                try {
                    for (var _d = __values(i.id), _e = _d.next(); !_e.done; _e = _d.next()) {
                        var t = _e.value;
                        if ((_c = (_b = input.confirmedValue.value) === null || _b === void 0 ? void 0 : _b.tourOperatorCodes) === null || _c === void 0 ? void 0 : _c.includes(t))
                            return true;
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
                return false;
            }); }
        },
        preferredDepartureDateFilter: {
            inputType: SearchMaskInputType.TRAVEL_PERIOD,
            mapToState: function (filter, input) {
                delete input.confirmedValue.value.preferredDepartureDate;
                return __assign(__assign({}, input.confirmedValue.value), (filter.model && { preferredDepartureDate: filter.model }));
            },
            mapFromState: function (filter, input) {
                var _a;
                return ((_a = input.confirmedValue.value) === null || _a === void 0 ? void 0 : _a.preferredDepartureDate) || null;
            }
        },
        ulmFilter: {
            inputType: SearchMaskInputType.TRAVEL_PERIOD,
            mapToState: function (filter, input) {
                return __assign(__assign({}, input.confirmedValue.value), { departureDate: filter.model ? format(new Date(), 'YYYY-MM-DD') :
                        store.getState().coreState.package.formData.travelPeriod.departureDate.min, exactDepartureDate: filter.model });
            },
            mapFromState: function (filter, input) {
                return input.confirmedValue.value.departureDate == format(new Date(), 'YYYY-MM-DD') &&
                    input.confirmedValue.value.exactDepartureDate;
            }
        }
    };
    return BaseFilterHelper;
}());
export { BaseFilterHelper };
